/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrapiBlockFromJSON, StrapiBlockToJSON, } from './StrapiBlock';
/**
 * Check if a given object implements the NewsletterComponent interface.
 */
export function instanceOfNewsletterComponent(value) {
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('yesLabel' in value) || value['yesLabel'] === undefined)
        return false;
    if (!('noLabel' in value) || value['noLabel'] === undefined)
        return false;
    if (!('activeCampaignListId' in value) || value['activeCampaignListId'] === undefined)
        return false;
    return true;
}
export function NewsletterComponentFromJSON(json) {
    return NewsletterComponentFromJSONTyped(json, false);
}
export function NewsletterComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'],
        'id': json['id'],
        'text': json['text'] == null ? undefined : (json['text'].map(StrapiBlockFromJSON)),
        'yesLabel': json['yesLabel'],
        'noLabel': json['noLabel'],
        'activeCampaignListId': json['activeCampaignListId'],
    };
}
export function NewsletterComponentToJSON(json) {
    return NewsletterComponentToJSONTyped(json, false);
}
export function NewsletterComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'id': value['id'],
        'text': value['text'] == null ? undefined : (value['text'].map(StrapiBlockToJSON)),
        'yesLabel': value['yesLabel'],
        'noLabel': value['noLabel'],
        'activeCampaignListId': value['activeCampaignListId'],
    };
}
